import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './store'
import {
  MS_FILE_EXT_EXCELX,
  MS_FILE_EXT_DOCX,
  MS_FILE_EXT_PPTX,
} from '../constants'

// add more dialog types here
export type Dialogs =
  | 'fileShareGoogle'
  | 'fileShareGoogleNew'
  | 'fileShareMS'
  | 'noAccess'
  | 'noShare'
  | 'collaborationNoShare'
  | 'collaborationNoShareNew'
  | 'collaborationInProgress'
  | 'collaborationInProgressNew'
  // ============================= Start V3 =============================
  // Delete me to go to back to native collaboration
  | 'fileShareMSNew'
  // ============================= End V3 =============================
  | 'joinError'

export type Dialog = {
  // whether the modal is open or not will be determined by if there is a type present to display
  type: Dialogs | null
  props?: {
    // newFileShare
    file:
      | typeof MS_FILE_EXT_EXCELX
      | typeof MS_FILE_EXT_DOCX
      | typeof MS_FILE_EXT_PPTX
    fileUrl?: string
  }
}

const initialState: Dialog = { type: null }

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    setDialog: (state, { payload: { type, props } }: PayloadAction<Dialog>) => {
      state.type = type
      state.props = props
    },
    closeDialog: (state) => {
      state.type = null
      state.props = undefined
    },
  },
})

export const { setDialog, closeDialog } = dialogSlice.actions

export const selectDialogProps = (state: RootState) => state.dialog.props
export const selectDialog = (state: RootState) => state.dialog.type

export default dialogSlice
